;(function ($) {

    var shareToggleButton = $('#share_toggle'),
        shareContainer = $('#share_container');

    $(document).ready(function () {
        $('body').on('click', '#show_hide_more_bio', lawyersBioShowHideToggle);
        initLawyersBioShowHideToggle();

        $('body').on('click', '#share_toggle', shareToggle);
        $('body').on('blur', 'a.social-share', blurShareContainer);
    });

    /**
     * Show/Hide Bio Toggle.
     */
    function lawyersBioShowHideToggle() {
        // console.log('lawyersBioShowHideToggle');
        let $this = $(this),
            content = $this.parents('.entry-content').find('.bio-container');

        if (content.hasClass('show-full')) {
            // console.log('close toggle');
            content.removeClass('show-full');
            $this.text('Show more of the bio');
            $this.removeClass('up-arrow');
        } else {
            // console.log('open toggle');
            content.addClass('show-full');
            $this.text('Show less of the bio');
            $this.addClass('up-arrow');
        }
    }

    /**
     * Init the Show/Hide Bio, Covers NO-JS
     */
    function initLawyersBioShowHideToggle() {
        // console.log('initLawyersBioShowHideToggle');
        let showHideContent = $('.bio-container'),
            showHideButton = $('.show-hide-more-bio');
        if (showHideContent) {
            if (!showHideContent.hasClass('too-short')) {
                showHideContent.removeClass('show-full');
            }
        }
    }

    /**
     * Toggles the Share Box in the Lawyers Single page and then focuses on the first item.
     *
     * @param {object} e
     * @returns {void}
     */
    function shareToggle() {
        // console.log('shareToggle');

        if (shareContainer.hasClass('open')) {
            // console.log('shareToggle has');
            shareContainer.removeClass('open');
            shareToggleButton.removeClass('open');
            shareToggleButton.attr('aria-expanded', 'false');
        } else {
            // console.log('shareToggle NOT has');
            shareContainer.addClass('open');
            shareToggleButton.addClass('open');
            shareToggleButton.attr('aria-expanded', 'true');
        }

    }

    /**
     * Closes the share container menu focusing out of of it and handles the aria-expanded logic.
     * @param e
     */
    function blurShareContainer(e) {
        // console.log('blurShareContainer', e);
        let $this = $(this);
        if (e.relatedTarget !== null) {
            let siblingClass = e.relatedTarget.classList.contains('social-share');
            if (siblingClass) {
                return;
            } else {
                shareContainer.removeClass('open');
                shareToggleButton.removeClass('open');
                shareToggleButton.attr('aria-expanded', 'false');
                shareToggleButton.focus();
            }
        }
    }


})(jQuery);
